import type { Load } from '@sveltejs/kit';

export let ssr = false;
export const prerender = false;

export const load: Load = async ({ url }) => {
	return {
		canonical_url: url.href,
		pathname: url.pathname
	};
};
